module.exports = __webpack_public_path__ + "media/rubber_2.f4e9b217.webm";